import {
    SET_CLIENT_INFO_SELECTED_STATE,
    SET_CLIENT_INFO_IS_OPEN,
    SET_CLIENT_INFO_COMPANY_NAME,
    SET_CLIENT_INFO_STREET,
    SET_CLIENT_INFO_STREET_2,
    SET_CLIENT_INFO_ZIP,
    SET_CLIENT_INFO_CITY,
    SET_COUNTRY,
    SET_CUSTOMER,
    ERASE_CUSTOMER,
} from './constants';


export const setCustomer = customer => ({
    type: SET_CUSTOMER,
    customer,
});
export const eraseCustomer = () => ({
    type: ERASE_CUSTOMER,
});
export const setClientInfoIsOpen = isOpen => ({
    type: SET_CLIENT_INFO_IS_OPEN,
    isOpen,
});

export const setClientInfoSelectedState = selectedState => ({
    type: SET_CLIENT_INFO_SELECTED_STATE,
    selectedState,
});

export const setCompanyName = companyName => ({
    type: SET_CLIENT_INFO_COMPANY_NAME,
    companyName,
});

export const setClientInfoStreet = street => ({
    type: SET_CLIENT_INFO_STREET,
    street,
});
export const setClientInfoStreet2 = street2 => ({
    type: SET_CLIENT_INFO_STREET_2,
    street2,
});

export const setClientInfoZip = Zip => ({
    type: SET_CLIENT_INFO_ZIP,
    Zip,
});
export const setClientInfoCity = city => ({
    type: SET_CLIENT_INFO_CITY,
    city,
});
export const setCountry = country => ({
    type: SET_COUNTRY,
    country,
});



// WEBPACK FOOTER //
// ./src/containers/AddClient/ClientInfo/actions.js